// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"dfcb6763","667":"10cf706f","737":"1e7626c5","977":"6c2584f3"}[chunkId] + ".chunk.js";
};